// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/core/svc_upload.proto (package com.diagnocat.core, syntax proto3)
/* eslint-disable */

import { Empty, proto3 } from "@bufbuild/protobuf";
import { UploadSession, UploadTarget } from "../../model/dto_upload_session_pb.js";
import { AssetContent_Report_UserUploaded_MPRPlane, AssetContent_Report_UserUploaded_ToothSlice } from "../../model/dto_asset_report_uploaded_pb.js";
import { Study } from "../../model/dto_study_pb.js";
import { Asset, GeneratedReportAsset } from "../../model/dto_asset_pb.js";
import { Tooth } from "../../model/dto_report_tooth_pb.js";
import { ReportAsset } from "../../pipelines/pipelines_pb.js";

/**
 * @generated from message com.diagnocat.core.FailSessionReq
 */
export const FailSessionReq = proto3.makeMessageType(
  "com.diagnocat.core.FailSessionReq",
  () => [
    { no: 1, name: "UploadSessionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 100, name: "Cancelled", kind: "message", T: Empty, oneof: "Reason" },
    { no: 101, name: "Error", kind: "message", T: FailSessionReq_UploadError, oneof: "Reason" },
  ],
);

/**
 * @generated from message com.diagnocat.core.FailSessionReq.UploadError
 */
export const FailSessionReq_UploadError = proto3.makeMessageType(
  "com.diagnocat.core.FailSessionReq.UploadError",
  () => [
    { no: 1, name: "FileID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "FailSessionReq_UploadError"},
);

/**
 * @generated from message com.diagnocat.core.FailSessionResp
 */
export const FailSessionResp = proto3.makeMessageType(
  "com.diagnocat.core.FailSessionResp",
  () => [
    { no: 1, name: "UploadSession", kind: "message", T: UploadSession },
  ],
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionReq
 */
export const StartUploadSessionReq = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionReq",
  () => [
    { no: 1, name: "User_Avatar", kind: "message", T: StartUploadSessionReq_UserSimpleFileUpload, oneof: "Upload" },
    { no: 2, name: "User_Signature", kind: "message", T: StartUploadSessionReq_UserSimpleFileUpload, oneof: "Upload" },
    { no: 4, name: "Chat_Upload", kind: "message", T: StartUploadSessionReq_ChatUploadFileUpload, oneof: "Upload" },
    { no: 11, name: "Organization_Logo", kind: "message", T: StartUploadSessionReq_OrganizationSimpleFileUpload, oneof: "Upload" },
    { no: 12, name: "Organization_Stamp", kind: "message", T: StartUploadSessionReq_OrganizationSimpleFileUpload, oneof: "Upload" },
    { no: 21, name: "OrganizationStaff_Stamp", kind: "message", T: StartUploadSessionReq_OrganizationStaffSimpleFileUpload, oneof: "Upload" },
    { no: 101, name: "Study_CBCT", kind: "message", T: StartUploadSessionReq_PatientSimpleMultiFileUpload, oneof: "Upload" },
    { no: 106, name: "Study_CBCT_DCCT", kind: "message", T: StartUploadSessionReq_PatientDCCTFileUpload, oneof: "Upload" },
    { no: 102, name: "Study_Panoramic_XRay", kind: "message", T: StartUploadSessionReq_PatientSimpleFileUpload, oneof: "Upload" },
    { no: 103, name: "Study_Intraoral_XRay", kind: "message", T: StartUploadSessionReq_PatientSimpleMultiFileUpload, oneof: "Upload" },
    { no: 104, name: "Study_IOS_Meshes", kind: "message", T: StartUploadSessionReq_PatientIOSMeshesUpload, oneof: "Upload" },
    { no: 105, name: "Study_Dental_Photo", kind: "message", T: StartUploadSessionReq_PatientAlbumSimpleMultiFileUpload, oneof: "Upload" },
    { no: 107, name: "Study_Dental_Video", kind: "message", T: StartUploadSessionReq_PatientSimpleMultiFileUpload, oneof: "Upload" },
    { no: 111, name: "Patient_Document", kind: "message", T: StartUploadSessionReq_PatientSimpleMultiFileUpload, oneof: "Upload" },
    { no: 112, name: "Patient_UploadedImage", kind: "message", T: StartUploadSessionReq_PatientUploadedImageUpload, oneof: "Upload" },
    { no: 113, name: "Tooth_UserUploadedSlice", kind: "message", T: StartUploadSessionReq_ToothUserUploadedSlices, oneof: "Upload" },
    { no: 114, name: "Tooth_UserUploadedMPRPlanes", kind: "message", T: StartUploadSessionReq_ToothUserUploadedMPRPlanes, oneof: "Upload" },
    { no: 121, name: "Report_StudioApplicationStateSnapshot", kind: "message", T: StartUploadSessionReq_StudioReportFileUpload, oneof: "Upload" },
    { no: 122, name: "Report_StudioGeometry", kind: "message", T: StartUploadSessionReq_StudioReportFileUpload, oneof: "Upload" },
  ],
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionReq.UserSimpleFileUpload
 */
export const StartUploadSessionReq_UserSimpleFileUpload = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionReq.UserSimpleFileUpload",
  () => [
    { no: 1, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "FilePath", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "StartUploadSessionReq_UserSimpleFileUpload"},
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionReq.OrganizationSimpleFileUpload
 */
export const StartUploadSessionReq_OrganizationSimpleFileUpload = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionReq.OrganizationSimpleFileUpload",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "FilePath", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "StartUploadSessionReq_OrganizationSimpleFileUpload"},
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionReq.OrganizationStaffSimpleFileUpload
 */
export const StartUploadSessionReq_OrganizationStaffSimpleFileUpload = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionReq.OrganizationStaffSimpleFileUpload",
  () => [
    { no: 1, name: "StaffID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "FilePath", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "StartUploadSessionReq_OrganizationStaffSimpleFileUpload"},
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionReq.PatientSimpleFileUpload
 */
export const StartUploadSessionReq_PatientSimpleFileUpload = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionReq.PatientSimpleFileUpload",
  () => [
    { no: 1, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "FilePath", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "StartUploadSessionReq_PatientSimpleFileUpload"},
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionReq.PatientAlbumSimpleMultiFileUpload
 */
export const StartUploadSessionReq_PatientAlbumSimpleMultiFileUpload = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionReq.PatientAlbumSimpleMultiFileUpload",
  () => [
    { no: 1, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Target" },
    { no: 2, name: "DentalPhotoAlbumID", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "Target" },
    { no: 3, name: "FilePaths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
  {localName: "StartUploadSessionReq_PatientAlbumSimpleMultiFileUpload"},
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionReq.PatientSimpleMultiFileUpload
 */
export const StartUploadSessionReq_PatientSimpleMultiFileUpload = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionReq.PatientSimpleMultiFileUpload",
  () => [
    { no: 1, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "BrowserOffsetMinutes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "FilePaths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "Ordered", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "ValidationError", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "StartUploadSessionReq_PatientSimpleMultiFileUpload"},
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionReq.PatientIOSMeshesUpload
 */
export const StartUploadSessionReq_PatientIOSMeshesUpload = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionReq.PatientIOSMeshesUpload",
  () => [
    { no: 1, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "BrowserOffsetMinutes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "FilePaths", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "RawMeshViewer", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "StartUploadSessionReq_PatientIOSMeshesUpload"},
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionReq.StudioReportFileUpload
 */
export const StartUploadSessionReq_StudioReportFileUpload = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionReq.StudioReportFileUpload",
  () => [
    { no: 1, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "StartUploadSessionReq_StudioReportFileUpload"},
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionReq.ToothUserUploadedSlices
 */
export const StartUploadSessionReq_ToothUserUploadedSlices = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionReq.ToothUserUploadedSlices",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Slices", kind: "message", T: AssetContent_Report_UserUploaded_ToothSlice, repeated: true },
  ],
  {localName: "StartUploadSessionReq_ToothUserUploadedSlices"},
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionReq.ToothUserUploadedMPRPlanes
 */
export const StartUploadSessionReq_ToothUserUploadedMPRPlanes = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionReq.ToothUserUploadedMPRPlanes",
  () => [
    { no: 1, name: "ToothID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "MPRPanes", kind: "message", T: AssetContent_Report_UserUploaded_MPRPlane, repeated: true },
  ],
  {localName: "StartUploadSessionReq_ToothUserUploadedMPRPlanes"},
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionReq.PatientDCCTFileUpload
 */
export const StartUploadSessionReq_PatientDCCTFileUpload = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionReq.PatientDCCTFileUpload",
  () => [
    { no: 1, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "VolumeFilePath", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "RawMetadataFilePath", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "BrowserOffsetMinutes", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ],
  {localName: "StartUploadSessionReq_PatientDCCTFileUpload"},
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionReq.PatientUploadedImageUpload
 */
export const StartUploadSessionReq_PatientUploadedImageUpload = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionReq.PatientUploadedImageUpload",
  () => [
    { no: 1, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "FilePath", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "StartUploadSessionReq_PatientUploadedImageUpload"},
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionReq.ChatUploadFileUpload
 */
export const StartUploadSessionReq_ChatUploadFileUpload = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionReq.ChatUploadFileUpload",
  () => [
    { no: 1, name: "FilePath", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ThreadID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "StartUploadSessionReq_ChatUploadFileUpload"},
);

/**
 * @generated from message com.diagnocat.core.StartUploadSessionResp
 */
export const StartUploadSessionResp = proto3.makeMessageType(
  "com.diagnocat.core.StartUploadSessionResp",
  () => [
    { no: 1, name: "UploadSession", kind: "message", T: UploadSession },
    { no: 2, name: "UploadTargets", kind: "message", T: UploadTarget, repeated: true },
    { no: 3, name: "Study", kind: "message", T: Study },
    { no: 4, name: "AssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.StartPipelinesUploadSessionReq
 */
export const StartPipelinesUploadSessionReq = proto3.makeMessageType(
  "com.diagnocat.core.StartPipelinesUploadSessionReq",
  () => [
    { no: 1, name: "AssetID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "PipelinesRunID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "GeneratedReport", kind: "message", T: GeneratedReportAsset },
  ],
);

/**
 * @generated from message com.diagnocat.core.NotifyFileUploadStartedReq
 */
export const NotifyFileUploadStartedReq = proto3.makeMessageType(
  "com.diagnocat.core.NotifyFileUploadStartedReq",
  () => [
    { no: 1, name: "FileID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.NotifyFileUploadStartedResp
 */
export const NotifyFileUploadStartedResp = proto3.makeMessageType(
  "com.diagnocat.core.NotifyFileUploadStartedResp",
  () => [
    { no: 1, name: "UploadSession", kind: "message", T: UploadSession },
  ],
);

/**
 * @generated from message com.diagnocat.core.NotifyFileUploadProgressReq
 */
export const NotifyFileUploadProgressReq = proto3.makeMessageType(
  "com.diagnocat.core.NotifyFileUploadProgressReq",
  () => [
    { no: 1, name: "FileID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.NotifyFileUploadProgressResp
 */
export const NotifyFileUploadProgressResp = proto3.makeMessageType(
  "com.diagnocat.core.NotifyFileUploadProgressResp",
  () => [
    { no: 1, name: "UploadSession", kind: "message", T: UploadSession },
  ],
);

/**
 * @generated from message com.diagnocat.core.NotifyFileUploadFinishedReq
 */
export const NotifyFileUploadFinishedReq = proto3.makeMessageType(
  "com.diagnocat.core.NotifyFileUploadFinishedReq",
  () => [
    { no: 1, name: "FileID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.NotifyFileUploadFinishedResp
 */
export const NotifyFileUploadFinishedResp = proto3.makeMessageType(
  "com.diagnocat.core.NotifyFileUploadFinishedResp",
  () => [
    { no: 1, name: "UploadSession", kind: "message", T: UploadSession },
  ],
);

/**
 * @generated from message com.diagnocat.core.NotifyFileUploadFinishedResp_Upcoming
 */
export const NotifyFileUploadFinishedResp_Upcoming = proto3.makeMessageType(
  "com.diagnocat.core.NotifyFileUploadFinishedResp_Upcoming",
  () => [
    { no: 1, name: "UploadSession", kind: "message", T: UploadSession, oneof: "Result" },
    { no: 2, name: "Ping", kind: "message", T: Empty, oneof: "Result" },
  ],
);

/**
 * @generated from message com.diagnocat.core.CloseSessionReq
 */
export const CloseSessionReq = proto3.makeMessageType(
  "com.diagnocat.core.CloseSessionReq",
  () => [
    { no: 1, name: "UploadSessionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.CloseSessionResp
 */
export const CloseSessionResp = proto3.makeMessageType(
  "com.diagnocat.core.CloseSessionResp",
  () => [
    { no: 1, name: "UploadSession", kind: "message", T: UploadSession },
    { no: 2, name: "ReportAssets", kind: "message", T: Asset, repeated: true },
    { no: 3, name: "Tooth", kind: "message", T: Tooth, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.ClosePipelinesUploadSessionReq
 */
export const ClosePipelinesUploadSessionReq = proto3.makeMessageType(
  "com.diagnocat.core.ClosePipelinesUploadSessionReq",
  () => [
    { no: 1, name: "UploadSessionIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "StorageVersionReceipts", kind: "message", T: StorageVersionReceipt, repeated: true },
  ],
);

/**
 * StorageVersionReceipt holds the versions returned by one session's upload PUTs.
 *
 * @generated from message com.diagnocat.core.StorageVersionReceipt
 */
export const StorageVersionReceipt = proto3.makeMessageType(
  "com.diagnocat.core.StorageVersionReceipt",
  () => [
    { no: 1, name: "SessionID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Files", kind: "message", T: StorageVersionReceipt_File, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.StorageVersionReceipt.File
 */
export const StorageVersionReceipt_File = proto3.makeMessageType(
  "com.diagnocat.core.StorageVersionReceipt.File",
  () => [
    { no: 1, name: "FileID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "StorageVersionReceipt_File"},
);

/**
 * @generated from message com.diagnocat.core.ClosePipelinesUploadSessionResp
 */
export const ClosePipelinesUploadSessionResp = proto3.makeMessageType(
  "com.diagnocat.core.ClosePipelinesUploadSessionResp",
  [],
);

/**
 * @generated from message com.diagnocat.core.StartPipelinesUploadSession_UpcomingReq
 */
export const StartPipelinesUploadSession_UpcomingReq = proto3.makeMessageType(
  "com.diagnocat.core.StartPipelinesUploadSession_UpcomingReq",
  () => [
    { no: 1, name: "Assets", kind: "message", T: ReportAsset, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.core.StartPipelinesUploadSession_UpcomingResp
 */
export const StartPipelinesUploadSession_UpcomingResp = proto3.makeMessageType(
  "com.diagnocat.core.StartPipelinesUploadSession_UpcomingResp",
  () => [
    { no: 1, name: "UploadSessions", kind: "message", T: StartPipelinesUploadSession_UpcomingResp_UploadSession, repeated: true },
    { no: 2, name: "ProtectedUploads", kind: "message", T: StartPipelinesUploadSession_UpcomingResp_ProtectedUploadsAck },
  ],
);

/**
 * @generated from message com.diagnocat.core.StartPipelinesUploadSession_UpcomingResp.UploadSession
 */
export const StartPipelinesUploadSession_UpcomingResp_UploadSession = proto3.makeMessageType(
  "com.diagnocat.core.StartPipelinesUploadSession_UpcomingResp.UploadSession",
  () => [
    { no: 1, name: "UploadSession", kind: "message", T: UploadSession },
    { no: 2, name: "UploadTargets", kind: "message", T: UploadTarget, repeated: true },
  ],
  {localName: "StartPipelinesUploadSession_UpcomingResp_UploadSession"},
);

/**
 * Acknowledgment that every returned session is protected.
 *
 * @generated from message com.diagnocat.core.StartPipelinesUploadSession_UpcomingResp.ProtectedUploadsAck
 */
export const StartPipelinesUploadSession_UpcomingResp_ProtectedUploadsAck = proto3.makeMessageType(
  "com.diagnocat.core.StartPipelinesUploadSession_UpcomingResp.ProtectedUploadsAck",
  () => [
    { no: 1, name: "VersionHeader", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "StartPipelinesUploadSession_UpcomingResp_ProtectedUploadsAck"},
);

